import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useTheme } from '../theme/ThemeContext';
import { COLORS, getThemeStyles } from '../theme/designSystem';

interface Props {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: string;
  accentColor?: string;
}

export const StatCard: React.FC<Props> = ({
  title,
  value,
  subtitle,
  icon,
  accentColor = COLORS.primary,
}) => {
  const { isDark } = useTheme();
  const theme = getThemeStyles(isDark);

  return (
    <View
      style={[
        styles.card,
        {
          backgroundColor: theme.cardBg,
          borderColor: theme.border,
          borderLeftColor: accentColor,
        },
      ]}
    >
      <View style={styles.topRow}>
        <Text style={[styles.title, { color: theme.textSecondary }]}>{title}</Text>
        {icon && <Text style={{ fontSize: 18 }}>{icon}</Text>}
      </View>
      <Text style={[styles.value, { color: theme.textPrimary }]}>{value}</Text>
      {subtitle && <Text style={[styles.subtitle, { color: theme.textSecondary }]}>{subtitle}</Text>}
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    flex: 1,
    minWidth: 140,
    padding: 16,
    borderRadius: 16,
    borderWidth: 1,
    borderLeftWidth: 4,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 6,
    elevation: 3,
  },
  topRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 6,
  },
  title: {
    fontSize: 11,
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  value: {
    fontSize: 26,
    fontWeight: '800',
    marginVertical: 2,
  },
  subtitle: {
    fontSize: 11,
    marginTop: 2,
  },
});
